import React from "react";

import { Image } from "Components/atoms/Image";
import { Typography } from "Components/atoms/Typography";
import { NavMenu } from "Components/molecules/NavMenu";

import {
  FooterContentDesktop,
  FooterContentWrapperDesktop,
  FooterWrapperDesktop,
  LogoWrapperDesktop,
  NavDescriptionDesktop,
  NavWrapperDesktop,
} from "./styles";

import { FooterProps } from "../types";
import { ReclameAquiSeal } from "Components/atoms/ReclameAqui/ReclameAquiSeal";

/**
 * Componente FooterDesktop
 *
 * Exibe o rodapé otimizado para dispositivos desktop.
 */
export const FooterDesktop: React.FC<FooterProps> = ({
  travelOptionsImage,
  travelOptionsImageAlt,
  logo: Logo,
  footerItems,
  descriptionTexts,
  subFooterText,
}) => {
  return (
    <FooterWrapperDesktop>
      <div>
        <Image src={travelOptionsImage} alt={travelOptionsImageAlt} />
        <FooterContentDesktop>
          <FooterContentWrapperDesktop>
            <LogoWrapperDesktop href="/">
              <Logo />
            </LogoWrapperDesktop>

            <NavWrapperDesktop>
              <NavMenu
                items={footerItems.map((item) => ({
                  label: item.label,
                  action: () => item.action(),
                }))}
              />
            </NavWrapperDesktop>

            <NavWrapperDesktop>
              <NavDescriptionDesktop>
                <>
                  {descriptionTexts.map((text, index) => (
                    <Typography
                      key={index}
                      variant="caption"
                      color="darkBlue"
                      align="left"
                    >
                      {text}
                    </Typography>
                  ))}
                  <ReclameAquiSeal />
                </>
              </NavDescriptionDesktop>
            </NavWrapperDesktop>
          </FooterContentWrapperDesktop>

          <Typography variant="caption" color="darkBlue" align="center">
            {subFooterText}
          </Typography>
        </FooterContentDesktop>
      </div>
    </FooterWrapperDesktop>
  );
};
